import React from 'react'
import { trackEvent } from '../../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../../context/MatchScreenContext'
import { DISCLOSURE_DEFAULT_BODY, DISCLOSURE_DEFAULT_LINK_TEXT } from '../../moduleRegistry'
import '../../styles/DisclosureModule/DisclosureBlock.scss'

const FEE_STRUCTURE_BASE_URL = '/disclosures/fee-structure'

export interface DisclosureBlockAdvisor {
  name: string
  cpdisclosure?: string | null
  cpcustomlink?: string
  accountId?: number
}

export interface DisclosureBlockProps {
  advisor: DisclosureBlockAdvisor
}

const resolveLinkUrl = (advisor: DisclosureBlockAdvisor): string => {
  if (advisor.cpcustomlink) return advisor.cpcustomlink
  if (advisor.accountId !== undefined) return `${FEE_STRUCTURE_BASE_URL}/${advisor.accountId}`
  return FEE_STRUCTURE_BASE_URL
}

const renderBody = (body: string) => (
  <div className="disclosure-block__body" dangerouslySetInnerHTML={{ __html: body }} />
)

export const DisclosureBlock = ({ advisor }: DisclosureBlockProps) => {
  const { state: { pageKey } } = useMatchScreen()
  const body = advisor.cpdisclosure || DISCLOSURE_DEFAULT_BODY
  const linkUrl = resolveLinkUrl(advisor)

  const handleClick = () => {
    trackEvent('MatchScreen', 'FeeStructureClick', {
      page_key: pageKey,
      advisor_name: advisor.name,
      url: linkUrl
    })
  }

  return (
    <li className="disclosure-block">
      <strong className="disclosure-block__name">{advisor.name}</strong>
      {renderBody(body)}
      <a
        className="disclosure-block__link"
        href={linkUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
      >
        {DISCLOSURE_DEFAULT_LINK_TEXT}
        <span className="disclosure-block__sr-only"> (opens in a new tab)</span>
      </a>
    </li>
  )
}
